<script lang="ts">
	import Link from "@components/common/Link.svelte";
	import type { HTMLAnchorAttributes } from "svelte/elements";
	import type { MenuItem } from "@core/schema/MenuItem.js";
	import { LinkVariant } from "./common/getLinkClass.js";

	const { menuItem, ...rest }: { menuItem: MenuItem } & Omit<HTMLAnchorAttributes, "href"> = $props();
</script>

<Link
	{...rest}
	href={menuItem.href}
	variant={LinkVariant.MenuItemLink}
	class={[
		"lg:font-inter text-fstonyx font-inter duration-300 transition-all no-underline py-4 px-4 lg:px-0 block lg:py-0",
		rest.class,
	]}
/>
